/* eslint-disable */
import { isObject } from './isObject.js';

export const emptyObject = Object.freeze({});

/* Perform no operation */
export function noop(a, b, c) {}

/* Always return false */
export const no = (a, b, c) => false;

/* Always return true */
export const yes = (a, b, c) => true;

/* Return same value */
export const identity = (_) => _;

export function looseEqual(a, b) {
    if (a === b) return true;
    const isObjectA = isObject(a);
    const isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            const isArrayA = Array.isArray(a);
            const isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (
                    a.length === b.length
                    && a.every((e, i) => looseEqual(e, b[i]))
                );
            } if (!isArrayA && !isArrayB) {
                const keysA = Object.keys(a);
                const keysB = Object.keys(b);
                return (
                    keysA.length === keysB.length
                    && keysA.every((key) => looseEqual(a[key], b[key]))
                );
            }
            /* istanbul ignore next */
            return false;
        } catch (e) {
            /* istanbul ignore next */
            return false;
        }
    } else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    } else {
        return false;
    }
}
// 去重
export const uniq = (arr) => Array.from(new Set(arr));

export const uniqBy = (arr, key) => uniq(arr.map((v) => v[key])).reduce((prev, cur) => {
    prev.push(data.find((v) => v[key] === cur));

    return prev;
}, []);

export const uniqByKey = (arr, key) => data.reduce((prev, cur) => {
    if (prev.some((v) => v[key] === cur[key])) {
        prev.push(cur);
    }

    return prev;
}, []);

export const trim = (val) => val.replace(/(^\s*)|(\s*$)/g, '');

export const getAliasUuid = () => {
    const array = new Uint32Array(5);
    window.crypto.getRandomValues(array);
    return array.join('-');
};
